import SearchBar from '@components/util/SearchBar';
import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { Table } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
import { DeleteButton, EditButton } from '../../util/buttons';
import { useDispatch } from 'react-redux';
import { handleError } from '../../store/features/alertSlice';
import businessUnitsService from '../../services/business_unit.service';
import BusinessUnitForm from './BusinessUnitForm';
import BusinessUnitEditForm from './BusinessUnitEditForm';
const BusinessUnitsList = _ref => {
  let {
    company,
    setCompany,
    loading,
    setLoading,
    handleToaster
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [index, setIndex] = useState(null);
  const [bussinessUnitToEdit, setBusinessUnitToEdit] = useState({});
  const deleteBu = async bu => {
    if (bu.project_business_units.length > 0) {
      handleToaster("You are trying to delete a Business Unit that has been assigned to a Project, please unassigned it from the Project to delete, otherwise set this Business Unit to 'Not Active' - thanks", 'warning');
    } else {
      if (window.confirm('Are you sure ?')) {
        try {
          setLoading(true);
          await businessUnitsService.delete(company.id, bu.id);
          setCompany({
            ...company,
            business_units: [...company.business_units.filter(business_unit => business_unit.id !== bu.id)]
          });
        } catch (e) {
          dispatch(handleError(e));
        } finally {
          setLoading(false);
        }
      }
    }
  };
  const headers = [{
    text: t('business_unit')
  }, {
    text: t('state')
  }, {
    text: ''
  }];
  const handleEdit = (bu, index) => {
    setIsEditing(true);
    setBusinessUnitToEdit(bu);
    setIndex(index);
  };
  const rows = company.business_units.map((bu, index) => {
    return {
      key: bu.id,
      columns: [bu.name, bu.state === 'active' ? 'Active' : 'Not Active', /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EditButton, {
        onClick: () => handleEdit(bu, index)
      }), /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => deleteBu(bu)
      }))]
    };
  });
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, "Business Unit Listing"), /*#__PURE__*/React.createElement(Card.Body, null, !isEditing && /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows
  }), isEditing && /*#__PURE__*/React.createElement(BusinessUnitEditForm, {
    setIsEditing: setIsEditing,
    bussinessUnitToEdit: bussinessUnitToEdit,
    setCompany: setCompany,
    company: company,
    loading: loading,
    setLoading: setLoading,
    index: index
  })));
};
export default BusinessUnitsList;